import Vue from 'vue';
import VueRouter from 'vue-router';
import { AuthStorage } from '@/common/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'loginResult',
    component: () => import(/* webpackChunkName: "LoginResult" */ '../views/LoginResult.vue'),
  },
  {
    path: '/btns',
    name: 'loginBtns',
    component: () => import(/* webpackChunkName: "LoginBtns" */ '../views/LoginBtns.vue'),
  },
  {
    path: '/awsc',
    name: 'awsc',
    component: () => import(/* webpackChunkName: "Awsc" */ '../views/Awsc.vue'),
  },
  {
    path: '/captcha',
    name: 'captcha',
    component: () => import(/* webpackChunkName: "Captcha" */ '../views/Captcha.vue'),
  },
  // not ready
  {
    path: '/login-intl',
    name: 'loginIntl',
    component: () => import(/* webpackChunkName: "LoginIntl" */ '../views/LoginIntl.vue'),
  },
  {
    path: '/login-intl/phone',
    name: 'loginIntlPhone',
    component: () => import(/* webpackChunkName: "LoginIntlPhoneEmail" */ '../views/LoginIntl/PhoneLoginView.vue'),
  },
  {
    path: '/login-intl/email',
    name: 'loginIntlEmail',
    component: () => import(/* webpackChunkName: "LoginIntlPhoneEmail" */ '../views/LoginIntl/EmailLoginView.vue'),
  },
  {
    path: '/login-cn',
    name: 'loginCN',
    component: () => import(/* webpackChunkName: "LoginCN" */ '../views/LoginCN/index.vue'),
    children: [
      {
        path: '/',
        name: 'loginCNChoose',
        component: () => import(/* webpackChunkName: "LoginCNChoose" */ '../views/LoginCN/LoginChoose.vue'),
      },
      {
        path: 'phone',
        name: 'loginCNPhone',
        component: () => import(/* webpackChunkName: "LoginCNPhone" */ '../views/LoginCN/LoginPhone.vue'),
      },
      {
        path: 'sms-code',
        name: 'loginSmsCode',
        component: () => import(/* webpackChunkName: "LoginCNSmsCode" */ '../views/LoginCN/LoginSmsCode.vue'),
      },
      {
        path: 'swipe',
        name: 'loginSwipe',
        component: () => import(/* webpackChunkName: "LoginCNSwipe" */ '../views/LoginCN/LoginSwipe.vue'),
      },
    ],
  },
];

const ENTRY_ROUTE_PREFIXES = ['/login-cn', '/login-intl'];

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isEntryRoute = ENTRY_ROUTE_PREFIXES.some((prefix) => to.path.startsWith(prefix));

  if (isEntryRoute && to.query.not_auto_create === 'true') {
    AuthStorage.set('not_auto_create', 'true');
  }
  //滑动验证 先下载 awsc sdk
  if (['awsc', 'loginSwipe'].includes(to.name) && !window.AWSC) {
    const script = document.createElement('script');
    script.src = 'https://g.alicdn.com/AWSC/AWSC/awsc.js';
    document.body.appendChild(script);
    script.onload = function () {
      next();
    };
  } else {
    next();
  }
});

export default router;
